import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const initExpand = () => {
  const sections = document.querySelectorAll('[data-expand]')

  sections.forEach((section) => {
    const inner = section.querySelector('[data-expand-inner]')
    const media = section.querySelector('[data-expand-media-holder]')
    const heading = section.querySelector('[data-expand-heading]')
    const content = section.querySelector('[data-expand-content]')
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top top',
        end: 'bottom bottom',
        scrub: true,
      },
    })

    tl.to(inner, {
      clipPath: 'inset(calc(0% - 0rem) 0rem round 0rem)',
      ease: 'power1.inOut',
    })

    tl.fromTo(media, {
			scale: 1.2
		}, {
			scale: 1,
			ease: 'power1.inOut'
		}, 0)

		if (window.innerWidth < 650) {
			tl.fromTo(heading, {
				y: 0,
			}, {
				y: -100,
				ease: 'power1.inOut'
			}, 0)
		} else {
			tl.fromTo(heading, {
				yPercent: -50,
			}, {
				yPercent: -150,
				ease: 'power1.inOut'
			}, 0)
		}

		tl.fromTo(content, {
			opacity: 0,
			y: 100,
		}, {
			opacity: 1,
			y: 0,
			ease: 'power1.inOut'
		}, 0)
  })
}
